import _ from 'lodash';
import dynamic from 'next/dynamic';
import { IS_SHOW_SECTION } from 'src/constants';
import styled from 'styled-components';

const Footer = dynamic(import('src/components/layouts/footer'));

const Layout = ({ children, data, hideFooter, dataset }) => {
  return (
    <>
      {IS_SHOW_SECTION === 'true' &&
      <LayoutWrapper
        background={{
          desktop: _.find(data?.dataSet, (el) => el?.key === 'background-desktop')?.value,
          mobile: _.find(data?.dataSet, (el) => el?.key === 'background-mobile')?.value
        }}
        className='layout'
        id='layout'
      >
        <div className='background-gradient'>
          <>
            <div className='contents'>
              {children}
            </div>
          </>
          {hideFooter !== true && <Footer dataset={dataset} />}
        </div>
      </LayoutWrapper>}
      {IS_SHOW_SECTION !== 'true' && <Footer dataset={dataset} />}
    </>
  );
};

const LayoutWrapper = styled.div`
  z-index: 1;
  display: block;
  overflow: unset;
  position: relative;
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100vw;
  height: auto;
  h1, h2 {
    display: none !important;
  }
  .contents {
    position: relative;
    height: auto;
  }
`;

export default Layout;
